import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {findKeysByName} from "../utils/helpers";
import {NavLink} from "react-router-dom";

const ProductTypes = ({ products, image, heading, description, benefits }) => {

    const renderBanner = () => (
        <div className="position-relative bg-secondary" style={{ overflow: "hidden" }}>
            <img
                src={image}
                className="img-fluid w-100"
                alt="Banner"
                style={{
                    objectFit: "cover",
                    maxHeight: "600px",
                    width: "100%",
                    mixBlendMode: "multiply",
                }}
            />
            <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100">
                <h2
                    className="d-none d-md-block text-white text-center text-uppercase p-2 bg-secondary bg-opacity-50"
                    data-aos="zoom-in"
                    style={{ letterSpacing: "5px" }}
                >
                    {heading}
                </h2>
                <h6
                    className="d-block d-md-none m-2 p-2 text-white text-center text-uppercase bg-secondary bg-opacity-50"
                    data-aos="zoom-in"
                    style={{ letterSpacing: "5px" }}
                >
                    {heading}
                </h6>
            </div>
        </div>
    );

    const renderDescription = () => (
        <div className="px-3 py-4">
            <h4 className="d-none d-md-block text-center text-uppercase">
                About This Range
            </h4>
            <h6 className="d-block d-md-none text-center text-uppercase">
                About This Range
            </h6>
            <p className="text-center text-muted mb-2">
                {description}
            </p>
        </div>
    );

    const renderBenefits = () => (
        <div className="container backGround py-3">
            <h4 className="d-none d-md-block text-center text-uppercase pt-2 mb-4" data-aos="fade-up">
                Benefits
            </h4>
            <h6 className="d-block d-md-none text-center text-uppercase pt-2 mb-4" data-aos="fade-up">
                Benefits
            </h6>
            <div className="row text-center g-4">
                {benefits.map((benefit, index) => (
                    <div className="col-12 col-lg-4" key={index} data-aos="fade-up">
                        <div className="icon mx-auto mb-3">
                            <FontAwesomeIcon icon={benefit.icon} size="2x" />
                        </div>
                        <p className="text-muted">{benefit.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );

    const renderOurRange = () => (
        <div className="container my-4">
            <h4 className="d-none d-md-block text-center text-uppercase mb-4" data-aos="fade-up">Our Range</h4>
            <h6 className="d-block d-md-none text-center text-uppercase mb-4" data-aos="fade-up">Our Range</h6>
            <div className="row g-4 justify-content-center align-items-center">
                {products.map((product, index) => {
                    const keys = findKeysByName(product.name);
                    return (
                        <div className="col-12 col-sm-6 col-md-4" key={index} data-aos="fade-up">
                            <div className="card shadow-sm border-0 h-100 text-center">
                                {keys ? (
                                    <NavLink
                                        to={`/products/${keys.categoryKey}/${keys.typeKey}`}
                                        className="d-block w-100"
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        <img
                                            src={product.src}
                                            alt={product.name}
                                            className="img-fluid rounded"
                                            style={{height: "200px", width: "100%", objectFit: "cover"}}
                                            data-aos="zoom-in"
                                        />
                                    </NavLink>
                                ) : (
                                    <img
                                        src={product.src}
                                        alt={product.name}
                                        className="img-fluid rounded"
                                        style={{height: "200px", width: "100%", objectFit: "cover"}}
                                        data-aos="zoom-in"
                                    />
                                )}
                                <p className="text-dark text-center py-2 mb-0">{product.name}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );

    return (
        <div className="container-fluid p-0">
            {renderBanner()}
            {renderDescription()}
            {renderBenefits()}
            {renderOurRange()}
        </div>
    );
};

export default ProductTypes;
